<template>
    <span class="connect-phone" :class="{loading: loading}">
        <slot>
            <span v-if="displayPhone">{{displayPhone}}</span>&nbsp;<a href="javascript://void"
                                                                      @click="requestCall">Make Outbound Call</a>
        </slot>

        <modal :name=modalId
               :adaptive="true"
               height="auto">
            <div class="dashboard-block">
                <header>
                    Contact Restricted
                    <a href="javascript://void" class="back" @click="closeModal">Close</a>
                </header>

                <p class="no-margin">The number {{displayPhone}} is a restricted contact. Continue?</p>

                <hr>

                <div class="row">
                    <div class="col-xs-6">
                        <button class="btn btn-link" type="button" @click="closeModal">Close</button>
                    </div>
                    <div class="col-xs-6 text-right">
                        <button class="btn btn-warning" type="button" @click="call">Confirm</button>
                    </div>
                </div>
            </div>
        </modal>
    </span>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },

            canCall: {
                type: Boolean,
                default: false
            },

            residentId: {
                type: String,
            },

            projectId: {
                type: String,
            },

            to: {
                type: String,
            },

            userId: {
                type: String,
            },
        },

        data(){
            return {
                loading: false,
            };
        },

        computed: {
            displayPhone(){
                if( this.to ){
                    return this.$options.filters.displayPhone( this.to );
                }
            },

            form(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/calls' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'POST' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                let data = {
                    'Call': {
                        'to': this.to,
                        'project_id': this.project_id
                    }
                };

                if( this.projectId ){
                    data[ 'Call' ][ 'project_id' ] = this.projectId;
                }

                const map = {
                    'to': this.to,
                    'project_id': this.projectId,
                    'resident_id': this.residentId,
                    'to_user_id': this.userId,
                };

                _.each( map, ( value, callIndex ) => {
                    if( !_.isNil( value ) ){
                        let field = document.createElement( 'input' );
                        field.setAttribute( 'type', 'hidden' );
                        field.setAttribute( 'name', 'Call[' + callIndex + ']' );
                        field.setAttribute( 'value', value );
                        form.appendChild( field );
                    }
                } );

                return form;
            }
        },

        methods: {
            requestCall(){
                if( this.canCall === false ){
                    return this.openModal();
                }

                return this.call();
            },

            call(){
                if( !this.to ){
                    this.$notify( {
                        duration: 0,
                        dismissible: true,
                        type: 'danger',
                        placement: 'top-left',
                        title: 'No Phone Number Found',
                    } );

                    throw new Error( 'No phone number found' );
                }

                this.loading = true;

                const form = this.form;

                document.body.appendChild( form );
                form.submit();
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    }
</script>
